import { ContentCutIcon } from './ContentCutIcon';

/**
 * author: Google
 * id D4028362-37C3-4EED-BE0B-C78927C3F55D
 * name content-cut
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-cut.svg
 * tags
 * - Health / Beauty 
 * - Text / Content / Format 
 */
export const ClipIcon = ContentCutIcon;
export default ClipIcon